/* SVELIA — ajout au panier soigné (19/10/2026).
   Bouton : reflet or qui file pendant l'ajout, puis coche or dessinée + « Ajouté ».
   Tiroir panier : les articles entrent l'un après l'autre. Uniquement transform et opacity ;
   rien si la cliente a réduit les animations. N'intervient pas dans l'ajout lui-même (Dawn / Pumper). */
(function () {
  if (window.__svAjout) return;
  window.__svAjout = true;
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var css = [
    '.sv button[name="add"]{position:relative;overflow:hidden}',
    '.sv button[name="add"] .loading__spinner{display:none!important}',
    '.sv button[name="add"] > span:first-child{transition:opacity .3s cubic-bezier(.22,.61,.36,1),transform .45s cubic-bezier(.22,.61,.36,1)}',
    '.sv button.sv-adding > span:first-child{opacity:.6}',
    '.sv button.sv-added > span:first-child{opacity:0;transform:translateY(-8px)}',
    '.sv-fx{position:absolute;inset:0;pointer-events:none;display:flex;align-items:center;justify-content:center;gap:10px;color:#F7F1EC;font:500 12px/1 Montserrat,sans-serif;letter-spacing:.16em;text-transform:uppercase}',
    '.sv button.sv-adding{opacity:1!important;cursor:progress}',
    '.sv-fx__sweep{position:absolute;top:0;bottom:0;left:0;width:38%;background:linear-gradient(90deg,rgba(217,191,148,0),rgba(217,191,148,.38),rgba(217,191,148,0));opacity:0;transform:translateX(-110%) skewX(-18deg)}',
    '.sv-adding .sv-fx__sweep{opacity:1;animation:svSweep 1.15s cubic-bezier(.45,0,.55,1) infinite}',
    '@keyframes svSweep{to{transform:translateX(290%) skewX(-18deg)}}',
    '.sv-fx__ok{display:flex;align-items:center;gap:10px;opacity:0;transform:translateY(8px);transition:opacity .35s cubic-bezier(.22,.61,.36,1),transform .5s cubic-bezier(.34,1.4,.64,1)}',
    '.sv-added .sv-fx__ok{opacity:1;transform:none}',
    '.sv-fx svg{width:20px;height:20px;flex:none}',
    '.sv-fx svg *{fill:none;stroke:#D9BF94;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1;stroke-dashoffset:1}',
    '.sv-added .sv-fx circle{stroke-dashoffset:0;transition:stroke-dashoffset .55s cubic-bezier(.22,.61,.36,1) .05s}',
    '.sv-added .sv-fx path{stroke-dashoffset:0;transition:stroke-dashoffset .35s cubic-bezier(.22,.61,.36,1) .4s}',
    'cart-drawer.sv-fresh .cart-item{animation:svItem .6s cubic-bezier(.22,.61,.36,1) both;animation-delay:calc(var(--n,0) * 90ms)}',
    'cart-drawer.sv-fresh .svc-duo{animation:svItem .6s cubic-bezier(.22,.61,.36,1) .25s both}',
    '@keyframes svItem{from{opacity:0;transform:translateY(14px)}}'
  ].join('\n');

  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var cur = null; // ajout en cours : { btn, timer, obs }

  function fx(btn) {
    var el = btn.querySelector('.sv-fx');
    if (el) return el;
    el = document.createElement('span');
    el.className = 'sv-fx';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<span class="sv-fx__sweep"></span><span class="sv-fx__ok">' +
      '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" pathLength="1" transform="rotate(-90 12 12)"/><path d="M7.5 12.4l3 3 6-6.4" pathLength="1"/></svg>' +
      (EN ? 'Added' : 'Ajouté') + '</span>';
    btn.appendChild(el);
    return el;
  }

  function stop() {
    if (!cur) return;
    clearTimeout(cur.timer);
    cur.obs.forEach(function (o) { o.disconnect(); });
    cur.btn.classList.remove('sv-adding');
    cur = null;
  }

  function freshDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    d.querySelectorAll('.cart-item').forEach(function (r, i) { r.style.setProperty('--n', i); });
    d.classList.remove('sv-fresh'); void d.offsetWidth; d.classList.add('sv-fresh');
    setTimeout(function () { d.classList.remove('sv-fresh'); }, 1600);
  }

  function showAdded(btn) {
    btn.classList.add('sv-added');
    setTimeout(function () { btn.classList.remove('sv-added'); }, 2000);
  }

  function success() {
    if (!cur) return;
    var btn = cur.btn;
    stop();
    // Le panier change juste avant l'ouverture du tiroir : on laisse le tiroir s'ouvrir avant de décider
    setTimeout(function () { after(btn); }, 350);
  }

  function after(btn) {
    freshDrawer();
    // Tiroir ouvert (mobile : il recouvre le bouton) : la coche s'affiche à sa fermeture
    var d = document.querySelector('cart-drawer');
    if (!d || !d.classList.contains('active')) { showAdded(btn); return; }
    var o = new MutationObserver(function () {
      if (d.classList.contains('active')) return;
      o.disconnect(); clearTimeout(t);
      setTimeout(function () { showAdded(btn); }, 250);
    });
    var t = setTimeout(function () { o.disconnect(); }, 15000);
    o.observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  function start(btn) {
    stop();
    fx(btn);
    btn.classList.remove('sv-added');
    btn.classList.add('sv-adding');
    cur = { btn: btn, obs: [], timer: setTimeout(stop, 8000) };
    // Réussite : le panier change (pastille de l'icône) ou le tiroir s'ouvre
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      var o1 = new MutationObserver(success);
      o1.observe(bubble, { childList: true, subtree: true });
      cur.obs.push(o1);
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var o2 = new MutationObserver(function () { if (drawer.classList.contains('active')) success(); });
      o2.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      cur.obs.push(o2);
    }
    // Échec : message d'erreur de la fiche
    var err = btn.closest('product-form');
    err = err && err.querySelector('.product-form__error-message-wrapper');
    if (err) {
      var o3 = new MutationObserver(function () { if (!err.hidden) stop(); });
      o3.observe(err, { attributes: true, attributeFilter: ['hidden'] });
      cur.obs.push(o3);
    }
  }

  function init() {
    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
    // Phase de bouillonnement : si svelia-taille.js bloque l'ajout (taille non choisie), ce clic n'arrive pas ici
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.sv button[name="add"]');
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
      start(btn);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
